import { Product } from '../modules/partner/action'

export type LabraProduct = Product | 'sales' | 'funding'

export const ProductRoutingMap: Record<LabraProduct, string> = {
  oppsync: 'oppsync',
  cloudfaas: 'cloudfaas',
  flyout: 'flyout',
  sales: 'labra-ai',
  funding: 'funding',
}

export const ProductRoutingMapShort: Record<LabraProduct, string> = {
  oppsync: 'OS',
  cloudfaas: 'CF',
  flyout: 'FO',
  sales: 'AI',
  funding: 'FN',
}
